import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Box } from '@mui/material';
import RightPanelBody from './right-panel-body';
import { StepIconProps } from '@mui/material/StepIcon';

const steps = ['Assignment Criteria', 'Assign To'];
const CustomStepIcon: React.FC<StepIconProps> = (props) => {
    const { active, completed, icon } = props;

    return (
        <div
            className={`custom-step-icon ${active ? 'active' : ''} ${completed ? 'completed' : ''}`}
        >
            <span>{icon}</span>
        </div>
    );
};

const RightPanel = () => {
    const [activeStep, setActiveStep] = React.useState(0);

    return (
        <>
            <div className="right-panel-header">
                <Box className="stepper-wrapper">
                    <Stepper
                        activeStep={activeStep}
                    >
                        {steps.map((label, index) => (
                            <Step
                                key={index}
                                completed={activeStep > index}
                            >
                                <StepLabel
                                    StepIconComponent={CustomStepIcon}
                                    onClick={() => { if (index === 0) setActiveStep(index); }}
                                    sx={{cursor:"pointer"}}
                                >
                                    {label}
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
            </div>
            <RightPanelBody activeStep={activeStep}
                setActiveStep={setActiveStep} />
        </>
    );
};

export default RightPanel;
